import { Logo } from 'theSource/components/Logo';
import {
  AppBarStyled,
  HeaderWrapperStyled,
  LogoWrapperStyled,
  ToolbarStyled,
  DrawerVisibleStyled,
  NameStyled,
  MobileAndTabletChatBotStyling,
} from './HeaderStyled';
import { Drawer, DesktopPopOver } from './components';
import { useSubscriberQuery } from 'theSource/queries';
import { ChatBot } from 'components/ChatBot';

interface HeaderProps {
  hideDrawer?: boolean;
  chatBot?: boolean;
}

export const Header = ({
  hideDrawer = false,
  chatBot = false,
}: HeaderProps) => {
  const { subscriber } = useSubscriberQuery({ restrictAdmin: true });

  const subscriberName =
    (subscriber?.data.first_name.value as string) +
    ' ' +
    (subscriber?.data?.last_name?.value as string);
  return (
    <HeaderWrapperStyled data-testid="header" role="banner">
      <AppBarStyled position="fixed">
        <ToolbarStyled>
          <LogoWrapperStyled>
            <Logo />
          </LogoWrapperStyled>
          <div className="d-flex">
            {chatBot && (
              <MobileAndTabletChatBotStyling>
                <ChatBot renderDefault={false} showText={false} />
              </MobileAndTabletChatBotStyling>
            )}
            {!hideDrawer && (
              <>
                <NameStyled variant="subtitle1">{subscriberName}</NameStyled>

                <DrawerVisibleStyled>
                  <Drawer />
                </DrawerVisibleStyled>

                <DesktopPopOver />
              </>
            )}
          </div>
        </ToolbarStyled>
      </AppBarStyled>
    </HeaderWrapperStyled>
  );
};
